import React from "react";
import { AppList } from "components/list/AppList";
import { ToggleActivityStateEnum } from "components/filters/ToggleActivityStateFilter";
import { Datagrid, TextField, EditButton, ReferenceField, BooleanField } from "react-admin";

import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { RecurringTaskType } from "../../../entities/RecurringTaskType";
import { DateFormatField } from "../../../components/fields/DateFormatField";
import { TaskServices } from "../../../entities/TaskService";
import { ObjectChipField } from "../../../components/fields/ObjectChipField";
import DeleteRestoreButtons from "../../../components/toolbars/DeleteRestoreButtons";
import { RecurringTasksFilter } from "./ListFilters";

const defaultSort = {
	field: "id",
	order: "DESC",
};

const filterDefaultValues = { activity_state: ToggleActivityStateEnum.ACTIVE };

const rowStyle = (record) => ({
	backgroundColor: record && record.is_deleted ? "#e0e0e0" : undefined,
});

const RecurringTasks = (props) => {
	return (
		<AppList
			sort={defaultSort}
			{...props}
			exporter={false}
			bulkActionButtons={false}
			filters={<RecurringTasksFilter />}
			filterDefaultValues={filterDefaultValues}
		>
			<Datagrid rowStyle={rowStyle}>
				<EditButton />
				<TextField source="title" />

				<ObjectChipField
					source="service"
					object={TaskServices}
					titleKey="short_name"
					tooltipKey="full_name"
				/>

				<DateFormatField source="start_date" />

				<SelectEnumField source="type" enumName="recurring_type" enumObj={RecurringTaskType} />

				<ReferenceField source="terminal_id" reference="terminal" link={false}>
					<TextField source="name" />
				</ReferenceField>

				<BooleanField source="priority" />

				<ReferenceField source="assignee_1" reference="company-users">
					<TextField source="full_name" />
				</ReferenceField>

				<ReferenceField source="assignee_2" reference="company-users">
					<TextField source="full_name" />
				</ReferenceField>

				<DeleteRestoreButtons
					confirmDeleteStringKey="osfc.dialogs.confirm_delete_recurring_task"
					confirmRestoreStringKey="osfc.dialogs.confirm_restore_recurring_task"
				/>
			</Datagrid>
		</AppList>
	);
};

export default RecurringTasks;
